import React from 'react';
import { MessageCircle, Phone, CalendarCheck, Tag } from 'lucide-react';

const WA = '917011370322';
const wa = (text) => `https://wa.me/${WA}?text=${encodeURIComponent(text)}`;

const goToContact = (e) => {
  if (window.location.pathname === '/') {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  }
};

const ACTIONS = [
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    icon: MessageCircle,
    href: wa('Hello Harpalyk, I would like to know more about your robotic cleaning solutions.'),
    external: true,
    color: 'bg-[#25D366] text-white',
  },
  { id: 'call', label: 'Call Now', icon: Phone, href: 'tel:+917011370322', color: 'bg-gray-900 text-white' },
  { id: 'demo', label: 'Request Demo', icon: CalendarCheck, href: '/#contact', onClick: goToContact, color: 'bg-emerald-600 text-white' },
  {
    id: 'quote',
    label: 'Get Quote',
    icon: Tag,
    href: wa('Hello Harpalyk, I would like to get a quote for a cleaning robot.'),
    external: true,
    color: 'bg-white text-gray-900 border border-black/10',
  },
];

const StickyContactBar = () => (
  <>
    {/* Desktop: right-edge vertical dock */}
    <div
      data-testid="sticky-contact-bar-desktop"
      className="hidden lg:flex fixed right-0 top-1/2 -translate-y-1/2 z-40 flex-col gap-2 pr-2"
    >
      {ACTIONS.map(({ id, label, icon: Icon, href, external, color, onClick }) => (
        <a
          key={id}
          href={href}
          onClick={onClick}
          {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
          data-testid={`contact-bar-${id}`}
          className={`group flex items-center gap-2 rounded-full shadow-lg ${color} pl-3 pr-3 py-3 text-sm font-medium overflow-hidden max-w-[46px] hover:max-w-[190px] transition-[max-width] duration-500`}
        >
          <Icon size={20} className="flex-shrink-0" />
          <span className="whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300">{label}</span>
        </a>
      ))}
    </div>

    {/* Mobile: bottom bar */}
    <div
      data-testid="sticky-contact-bar-mobile"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-xl border-t border-black/10 shadow-[0_-4px_20px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="grid grid-cols-4">
        {ACTIONS.map(({ id, label, icon: Icon, href, external, onClick }) => (
          <a
            key={id}
            href={href}
            onClick={onClick}
            {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
            data-testid={`contact-bar-mobile-${id}`}
            className="flex flex-col items-center gap-1 py-2.5 text-gray-800 active:bg-gray-100 transition-colors duration-200"
          >
            <Icon size={19} className={id === 'whatsapp' ? 'text-[#25D366]' : id === 'demo' ? 'text-emerald-600' : ''} />
            <span className="text-[10px] font-medium leading-none">{label}</span>
          </a>
        ))}
      </div>
    </div>
  </>
);

export default StickyContactBar;
